import { apiRequest } from './client';
import type {
  BillingHistoryPage,
  CreditBalanceView,
  CreditProductView,
} from './types';

export const billing = {
  balance: (organizationId: string) =>
    apiRequest<CreditBalanceView>('/api/billing/balance', { organizationId }),

  history: (organizationId: string, page = 0, size = 20) =>
    apiRequest<BillingHistoryPage>('/api/billing/history', {
      organizationId,
      query: { page, size },
    }),

  // Public endpoint — no auth, no org header required.
  products: () => apiRequest<CreditProductView[]>('/api/billing/products'),
};
